import moment from "moment";
import Model from "./model";

const SIM_STATUS = {
  READY: "ready", /* 準備中 */
  ACTIVE: "active", /* 利用中 */
  SUSPENDED: "suspended", /* 再利用可能 */
  TERMINATED: "terminated", /* 利用不可 */
};

const MONITORING_DEVICE_STATUS = {
  READY: "ready", /* 準備中 */
  ACTIVE: "active", /* 利用中 */
  SUSPENDED: "suspended", /* 再利用可能 */
  TERMINATED: "terminated", /* 利用不可 */
};

class MonitoringDevice extends Model {
  /* eslint-disable no-unused-expressions */
  constructor(projectId, monitoringDeviceId = null) {
    super();
    this._projectId = projectId;
    this._monitoringDeviceId = monitoringDeviceId;

    this._monitoringDeviceType;
    this._productKey = "";
    this._name = "";
    this._monitoringDeviceStatus;
    this._simStatus;
    this._terminateAt;
    this._organizationId;
  }
  /* eslint-enable */

  get projectId() {
    return this._projectId;
  }

  set projectId(value) {
    this._projectId = value;
  }

  get monitoringDeviceId() {
    return this._monitoringDeviceId;
  }

  set monitoringDeviceId(value) {
    this._monitoringDeviceId = value;
  }

  get monitoringDeviceType() {
    return this._monitoringDeviceType;
  }

  set monitoringDeviceType(value) {
    this._monitoringDeviceType = value;
  }

  get organizationId() {
    return this._organizationId;
  }

  set organizationId(value) {
    this._organizationId = value;
  }

  get productKey() {
    return this._productKey;
  }

  set productKey(value) {
    this._productKey = value;
  }

  get name() {
    return this._name;
  }

  set name(value) {
    this._name = value;
  }

  get monitoringDeviceStatus() {
    return this._monitoringDeviceStatus;
  }

  set monitoringDeviceStatus(value) {
    this._monitoringDeviceStatus = value;
  }

  get simStatus() {
    return this._simStatus;
  }

  set simStatus(value) {
    this._simStatus = value;
  }

  get terminateAt() {
    return this._terminateAt;
  }

  set terminateAt(value) {
    this._terminateAt = value;
  }

  isRegisterd() {
    return !!this.monitoringDeviceId;
  }

  getTerminateAtText(format = "YYYY/MM/DD") {
    let res = "";
    if (this.terminateAt) {
      const renewalAt = moment(this.terminateAt);
      res = renewalAt.format(format);
    }
    return res;
  }

  json() {
    return {
      ...super.json(),
      projectId: this.projectId,
      monitoringDeviceId: this.monitoringDeviceId,
      monitoringDeviceType: this.monitoringDeviceType,
      organizationId: this.organizationId,
      productKey: this.productKey,
      name: this.name,
      monitoringDeviceStatus: this.monitoringDeviceStatus,
      simStatus: this.simStatus,
      terminateAt: this.terminateAt,
    };
  }

  copy() {
    const monitoringDevice = new MonitoringDevice(this.projectId, this.monitoringDeviceId);
    monitoringDevice.copyProperties(this);
    return monitoringDevice;
  }

  copyProperties(monitoringDevice) {
    super.copyProperties(monitoringDevice);

    this.projectId = monitoringDevice.projectId;
    this.monitoringDeviceId = monitoringDevice.monitoringDeviceId;
    this.monitoringDeviceType = monitoringDevice.monitoringDeviceType;
    this.organizationId = monitoringDevice.organizationId;
    this.productKey = monitoringDevice.productKey;
    this.name = monitoringDevice.name;
    this.monitoringDeviceStatus = monitoringDevice.monitoringDeviceStatus;
    this.simStatus = monitoringDevice.simStatus;
    this.terminateAt = monitoringDevice.terminateAt;
  }

  getApiRequestJson() {
    const requestJosn = super.getApiRequestJson();

    Object.assign(requestJosn, {
      project_id: this.projectId,
      monitoring_device_id: this.monitoringDeviceId,
      monitoring_device_type: this.monitoringDeviceType,
      product_key: this.productKey,
      name: this.name,
      monitoring_device_status: this.monitoringDeviceStatus,
      sim_status: this.simStatus,
      terminate_at: this.terminateAt,
      organization_id: this.organizationId,
    });
    return requestJosn;
  }

  setApiResponseJosn(item) {
    super.setApiResponseJosn(item);

    this.monitoringDeviceId = item.monitoring_device_id;
    this.monitoringDeviceType = item.monitoring_device_type;
    this.productKey = item.product_key;
    this.name = item.name;
    this.monitoringDeviceStatus = item.monitoring_device_status;
    this.simStatus = item.sim_status;
    this.terminateAt = item.terminate_at;
    this.organizationId = item.organization_id;
  }
}

export {
  MonitoringDevice,
  MONITORING_DEVICE_STATUS,
  SIM_STATUS,
};
